// extracted by mini-css-extract-plugin
module.exports = {"section":"about-us_section__W23z2"};